import { render, staticRenderFns } from "./OpportunityNegotiationFields.vue?vue&type=template&id=135abed8&scoped=true&"
import script from "./OpportunityNegotiationFields.vue?vue&type=script&lang=js&"
export * from "./OpportunityNegotiationFields.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityNegotiationFields.vue?vue&type=style&index=0&id=135abed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135abed8",
  null
  
)

export default component.exports